module.exports = __webpack_public_path__ + "img/lowerbanner.8af1d5f5.jpg";